import React, { useCallback } from 'react'

import styles from './CheckToggle.module.css'

const CheckToggle = ({ title, options, onChange, value }) => {
  const onClick = useCallback((newValue) => () => onChange(newValue), [
    onChange,
  ])

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.options}>
        {options.map((option, i) => {
          const selected = option.value === value
          return (
            <span
              key={i}
              className={
                selected ? `${styles.option} ${styles.selected}` : styles.option
              }
              onClick={!selected ? onClick(option.value) : undefined}
            >
              {selected ? (
                <i className="fa fa-check-circle"></i>
              ) : (
                <i className="far fa-circle"></i>
              )}{' '}
              {option.label}
            </span>
          )
        })}
      </div>
    </div>
  )
}

export default CheckToggle
